import { AsyncPipe, formatDate } from '@angular/common';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { selectAllCarImagesFolders, selectLoggedInUserDataId, selectDealerMyFavoriteCarsIds, selectAuthUserId, selectLoggedInUserData } from 'src/app/common/store/state/app.state';

import { CarCardHorizontalComponent } from '../car-card-horizontal/car-card-horizontal.component';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { NumberDialogComponent } from 'src/app/public/common/components/number-dialog/number-dialog.component';
import { Car } from '../../models/car.model';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { FileData } from 'src/app/public/common/models/file-data.model';

@Component({
    selector: 'app-car-card-list',
    templateUrl: './car-card-list.component.html',
    styleUrls: ['./car-card-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatProgressSpinnerModule, CarCardHorizontalComponent, AsyncPipe]
})
export class CarCardListComponent implements OnInit {

  @Input() businessLine?: CarBusinessLine;

  sessionInfo = "Click to update data";

  progressInfos: any[] = [];
  message: string[] = [];

  currentImageIndex: number = 0;

  @Input() fetchingResults: boolean = false;
  @Input() cars: Car[] = [];

  currentUserId$: Observable<string>;
  currentUser$: Observable<Dealer>;

  carImagesFolders$: Observable<Map<string, Array<FileData>>>;

  currentUserFavorites: string[] = [];

  CarBusinessLine =  CarBusinessLine;

  constructor(
    private store: Store, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog) {

      this.carImagesFolders$ = store.select(selectAllCarImagesFolders);
      //this.currentUserId$ = store.select(selectLoggedInUserDataId);
      this.currentUserId$ = store.select(selectAuthUserId);
      this.currentUser$ = store.select(selectLoggedInUserData);

    }
  
  ngOnInit(): void {


    } 
 
  moneyFormat(s: string): string{
    return AppFunctions.numberWithSpaces(s);
  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDate(dt);
  }

  createImageFromBlob(imageData: Blob): any {
    let objectUrl = URL.createObjectURL(imageData);     
    return this.sanitizer.bypassSecurityTrustUrl(objectUrl);    
  }

  openOfferDialog(carId: string, index: number): void {
    let amount = 0
    const dialogRef = this.dialog.open(NumberDialogComponent, {
      data: {amount: amount, label: "Offer"}
    });

    dialogRef.afterClosed().subscribe((result: number) => {
      console.log('New offer = '+result+ " car Id = "+carId);

      if(result > 0 )
        this.store.dispatch(DealerActions.createNewCarOfferSubmit( {carId: carId, amount: result}));

    });
  }

  isFavorite(carId: string): boolean{
    let isFav = false;
    if(this.currentUserFavorites != undefined)
      isFav = (carId === this.currentUserFavorites.find(x => x === carId))!;
    
    return isFav;
  } 
}

  


